import { Indicator, Toast, MessageBox } from 'mint-ui'
// const localeTimeString = () => new Date().toLocaleTimeString()
/**
 * 异步请求
 */
export function AsyncRequest({
  loading = false, // 请求中
  loadingText, // 提示文本
  toastError = true, // 提示加载失败（默认提示）
  request, // 请求
  resolve, // 成功的结果
  reject // 失败的结果
}) {
  const loadStatus = loading
  loading = action => {
    if (loadStatus) {
      if (action === 'open') {
        Indicator.open(loadingText)
      } else {
        Indicator.close()
        // console.log('Indicator.close', localeTimeString())
      }
    }
  }
  loading('open')

  const asyncResult = request()
  asyncResult
    .then(res => {
      resolve && resolve(res)
      loading(({ close }) => close())
    })
    .catch(error => {
      // 数据包里记录失败状态
      error.data = error.data || {}
      if (typeof error.data === 'object') {
        error.data.errorCode = error.code
      }

      reject && reject(error)
      loading('close')
      // 友好的错误提示
      let { message } = error
      const { data } = error
      if (message && toastError) {
        if (error.code === 10001) {
          return
        }
        if (message === 'Network Error') message = '请求超时'
        if (message.indexOf('timeout of') >= 0) message = '连接超时'
        // 合并账号特殊提醒  10021, 10025
        if ([10021, 10025].indexOf(error.code) > -1) {
          message = '可在友邻少年APP选择手机号登录，如需换绑微信，可在“我的-设置-账号/绑定设置”中进行换绑'
          const title = `您的手机号已注册友邻平台，且与"${data.nickname || ''}"账号绑定`
          return MessageBox({ message, title })
        }
        // 订单计算错误提醒
        if ([30012].indexOf(error.code) > -1) {
          return console.log('结算金额计算错误--------', message)
        }
        // 5261142没有邀请权限 5261143自己邀请自己
        if ([5261142, 5261143].indexOf(error.code) > -1) {
          return console.log('邀请失败', message)
        }
        // 不弹窗返回前台处理
        if ([30140, 40400, 30421, 30143, 30025, 30425, 30430].indexOf(error.code) > -1) {
          return console.log('不弹窗返回前台处理------', message)
        }
        if (data && !message && typeof data === 'string') {
          message = data // 使用业务的错误提示
        }
        Toast({ message, position: 'middle' })
      }
    })
  return asyncResult
}

export function TimeLoading(api, { isOpen } = {}) {
  // 查询用户信息(使用 code 查询)
  let time1 = 0
  let time2 = 0
  const loading = (action, loadingText) => {
    isOpen = isOpen === undefined ? action === 'open' : isOpen
    if (api) {
      if (isOpen) {
        time1 = new Date().getTime()
        console.log(`[WXLogin] ${api}> start`)
      } else {
        time2 = new Date().getTime()
        const ms = (time2 - time1) / 1000 + 's'
        console.log(`[WXLogin] ${api}> end`, ms)
      }
    }
    if (isOpen) {
      Indicator.open(loadingText)
    } else {
      Indicator.close()
      // console.log('Indicator.close', localeTimeString())
    }
  }
  return loading
}
